import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncSetReportBusinessUnitModal = Loadable({
  loader: () => /* webpackChunkName: "reporting-action-components-modals" */import('./SetReportBusinessUnitModal'),
  LoadingComponent: () => null
});